import { SpeakersState } from './types';

export const initialState: SpeakersState = {
  speakers: null,
  loadingSpeakers: false,
};
